/* eslint-disable linebreak-style */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';
import { t } from '../../../../i18n';


// Create styles
const styles = StyleSheet.create({
  section: {
    marginLeft: 25,
    marginTop: 5,
    marginBottom: 5,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  // Stil pentru rândul de observații
  rowObservatii: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    width: '770px'
  },
});

// Definim componente reutilizabile pentru celule, cu dimensiuni fixe
const HeaderCell = styled.Text`
  padding: 5px;
  font-size: 8px;
  margin-left: -1px;
  margin-top: -1px;
  border: 1px solid;
  text-align: center;
`;

const BodyCell = styled.Text`
  padding: 5px;
  font-size: 8px;
  margin-left: -1px;
  margin-top: -1px;
  border: 1px solid;
  text-align: center;
`;

const CellNrCrt = styled(BodyCell)`
  display: flex;
  width: 30px;  
`;

const CellTipSubprodus = styled(BodyCell)`
  width: 80px;
`;

const CellCod = styled(BodyCell)`
  width: 35px;
`;

const CellMaterial = styled(BodyCell)`
  width: 55px;
`;

const CellDimensiuni = styled(BodyCell)`
  width: 45px;
`;

const CellActionare = styled(BodyCell)`
  width: 50px;
`;

const CellAx = styled(BodyCell)`
  width: 35px;
`;

const CellCuloareComp = styled(BodyCell)`
  width: 60px;
`;

const CellOptional = styled(BodyCell)`
  width: 60px;
`;

const CellCantitate = styled(BodyCell)`
  width: 40px;
`;

const CellPret = styled(BodyCell)`
  width: 70px;
`;

// Stil pentru celula `CellTotal` fără border
const CellTotal = styled.Text`
  width: 100%;
  text-align: right;
  font-size: 15px;
  padding: 15px;
  margin-left: -1px;
  margin-top: -1px;
  /* Eliminăm border-ul */
`;

const CellObservatii = styled(BodyCell)`
  width: 100%;
  text-align: left;
  border: 1px solid; /* Adăugăm border pentru observații */
  flex: 1; /* Permite celulei să ocupe tot spațiul pe înălțime */
`;

// Create Document Component
const ContentRO = (props) => (
  <View style={styles.section}>
    {/* Capul de tabel */}
    <View style={styles.row}>
      <HeaderCell style={{ width: '30px' }}>{t('pdf.content.nrCrt')}</HeaderCell>
      <HeaderCell style={{ width: '80px' }}>{t('pdf.content.tipRoleta')}</HeaderCell>
      <HeaderCell style={{ width: '35px' }}>{t('pdf.content.cod')}</HeaderCell>
      <HeaderCell style={{ width: '55px' }}>{t('pdf.content.material')}</HeaderCell>
      <HeaderCell style={{ width: '45px' }}>{t('pdf.content.lungimePanza')}</HeaderCell>
      <HeaderCell style={{ width: '45px' }}>{t('pdf.content.lungimeFinala')}</HeaderCell>
      <HeaderCell style={{ width: '45px' }}>{t('pdf.content.inaltimePanza')}</HeaderCell>
      <HeaderCell style={{ width: '45px' }}>{t('pdf.content.inaltimeFinala')}</HeaderCell>
      <HeaderCell style={{ width: '50px' }}>{t('pdf.content.actionare')}</HeaderCell>
      <HeaderCell style={{ width: '35px' }}>{t('pdf.content.ax')}</HeaderCell>
      <HeaderCell style={{ width: '60px' }}>{t('pdf.content.culoareComp')}</HeaderCell>
      <HeaderCell style={{ width: '60px' }}>{t('pdf.content.optional1')}</HeaderCell>
      <HeaderCell style={{ width: '60px' }}>{t('pdf.content.optional2')}</HeaderCell>
      <HeaderCell style={{ width: '60px' }}>{t('pdf.content.optional3')}</HeaderCell>
      <HeaderCell style={{ width: '40px' }}>{t('pdf.content.cant')}</HeaderCell>
      <HeaderCell style={{ width: '70px' }}>{t('pdf.content.pretLei')}</HeaderCell>
    </View>

    {/* Rândurile tabelului */}
    {props.currentOrder.comandarepers ?
      props.currentOrder.comandarepers.sort((a, b) => {
        return new Date(a.actionare) - new Date(b.actionare);
      }).map(item =>
        <React.Fragment key={item.id}>
          {/* Îmbinarea rândurilor într-un singur container */}
          <View style={styles.row}>
            {/* Celula NrCrt ocupă înălțimea ambelor rânduri */}
            <CellNrCrt>{item.nrCrt}</CellNrCrt>
            {/* Primul rând cu detalii produs */}
            <View style={{ flexDirection: 'column', flex: 1 }}>
              <View style={styles.row}>
                <CellTipSubprodus>{item.denumireSubProdus}</CellTipSubprodus>
                <CellCod>{item.codMaterial}</CellCod>
                <CellMaterial>{item.denumireMaterial}</CellMaterial>
                <CellDimensiuni>{item.lungime}</CellDimensiuni>
                <CellDimensiuni>{item.lungimeFinala}</CellDimensiuni>
                <CellDimensiuni>{item.inaltime}</CellDimensiuni>
                <CellDimensiuni>{item.inaltimeFinala}</CellDimensiuni>
                <CellActionare>{item.actionareStDr}</CellActionare>
                <CellAx>{item.ax}</CellAx>
                <CellCuloareComp>{item.denumireCuloareLamela}</CellCuloareComp>
                <CellOptional>{item.denumireOptional1}</CellOptional>
                <CellOptional>{item.denumireOptional2}</CellOptional>
                <CellOptional>{item.denumireOptional3}</CellOptional>
                <CellCantitate>{item.buc}</CellCantitate>
                <CellPret>{item.pretCuDiscount}</CellPret>
              </View>

              {/* Al doilea rând pentru observații */}
              {item.observatii ?
              <View style={styles.rowObservatii}>
                <CellObservatii>{t('pdf.common.obsPrefix')} {item.observatii}</CellObservatii>
              </View>
              : null
              }
            </View>
          </View>
        </React.Fragment>
      )
      : <Text>{t('pdf.common.noRows')}</Text>
    }

    {/* Total fără border */}
    <View style={styles.row}>
      <CellTotal>{t('pdf.common.total', { value: props.currentOrder.valoareComanda, currency: 'lei' })}</CellTotal>
    </View>
  </View>
);



export default ContentRO